import { useState, useEffect } from "react";
import useCustomerCharges from "../useCustomerCharges/useCustomerCharges";
import useCarrierLedgerCharges from "../useCarrierLedgerCharges/useCarrierLedgerCharges";
import { getSumOfArrayOfObjects } from "../../utils/calcHelpers";

export default function useBuildLedgerRows(load, carrierExtraPay) {
  const { customerLinehaul, customerFuel, customerAccessorials } = useCustomerCharges(load);
  const { carrierLinehaul, carrierFuel, carrierAccessorials, paidCarrierComchecks } = useCarrierLedgerCharges(carrierExtraPay, load);
  const [ledgerDetailRows, setLedgerDetailRows] = useState([]);
  const [customerDeductions] = useState([]);
  const [carrierDeductions, setCarrierDeductions] = useState([]);

  const buildLedgerDetailRows = () => {
    const customerFuelTotal = getSumOfArrayOfObjects(customerFuel, "amount");
    const customerAccTotal = getSumOfArrayOfObjects(customerAccessorials, "amount");
    const carrierFuelTotal = getSumOfArrayOfObjects(carrierFuel, "amount");
    const carrierAccTotal = getSumOfArrayOfObjects(carrierAccessorials.filter(a => a.deductCodeId !== "DRB" || a.payeeId !== "CAPSTOG1"), "amount");
    const customerDeductionsTotal = getSumOfArrayOfObjects(customerDeductions, "amount");
    const carrierDeductionsTotal = getSumOfArrayOfObjects(carrierDeductions, "amount");
    const otherCostTotal = getSumOfArrayOfObjects(carrierAccessorials.filter(a => a.deductCodeId === "DRB" && a.payeeId === "CAPSTOG1"), "amount");

    const rows = [];
    rows.push(
      {
        description: "Line Haul",
        customerCharge: customerLinehaul,
        carrierCost: carrierLinehaul,
        otherCost: 0,
        profit: customerLinehaul - carrierLinehaul,
        isVisible: true
      },
      {
        description: "Fuel",
        customerCharge: customerFuelTotal,
        carrierCost: carrierFuelTotal,
        otherCost: 0,
        profit: customerFuelTotal - carrierFuelTotal,
        isVisible: true
      },
      {
        description: "Other",
        customerCharge: customerAccTotal,
        carrierCost: carrierAccTotal,
        otherCost: otherCostTotal,
        profit: customerAccTotal - carrierAccTotal,
        isVisible: true
      },
    );

    customerAccessorials.forEach(a => rows.push(
      {
        description: a.description,
        customerCharge: a.amount,
        carrierCost: 0,
        otherCost: 0,
        profit: a.amount - 0,
        isVisible: false
      }
    ));

    carrierAccessorials.forEach(a => rows.push(
      {
        description: a.shortDescription,
        customerCharge: 0,
        carrierCost: a.deductCodeId !== "DRB" || a.payeeId !== "CAPSTOG1" ? a.amount : 0,
        otherCost: a.deductCodeId === "DRB" && a.payeeId === "CAPSTOG1" ? a.amount : 0,
        profit: a.deductCodeId !== "DRB" || a.payeeId !== "CAPSTOG1" ? 0 - a.amount : 0,
        isVisible: false
      }
    ));

    paidCarrierComchecks.forEach(paid => rows.push(
      {
        description: paid.shortDescription,
        customerCharge: 0,
        carrierCost: 0 - paid.amount,
        otherCost: 0,
        profit: paid.amount,
        isVisible: false
      }
    ));

    rows.push({
      description: "Total",
      customerCharge: customerLinehaul + customerFuelTotal + customerAccTotal - customerDeductionsTotal,
      carrierCost: carrierLinehaul + carrierFuelTotal + carrierAccTotal - carrierDeductionsTotal,
      otherCost: otherCostTotal,
      profit: (customerLinehaul + customerFuelTotal + customerAccTotal - customerDeductionsTotal) - (carrierLinehaul + carrierFuelTotal + carrierAccTotal - carrierDeductionsTotal),
      isVisible: true
    });

    setLedgerDetailRows(rows);
  };

  useEffect(() => {
    setCarrierDeductions(paidCarrierComchecks);
  }, [paidCarrierComchecks]);

  useEffect(() => {
    buildLedgerDetailRows();
  }, [
    customerLinehaul,
    customerFuel,
    customerAccessorials,
    carrierLinehaul,
    carrierFuel,
    carrierAccessorials,
    paidCarrierComchecks,
    customerDeductions,
    carrierDeductions
  ]);

  return { ledgerDetailRows };
}